import { toast } from 'react-toastify';

import { API_DOMAIN } from '../const';

export default function uploadImage(file) {
    const formData = new FormData();

    formData.append('file', file);
    formData.append('dir', 'media');

    const reqParams = {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            enctype: 'multipart/form-data',
        },
        body: formData,

    };

    return fetch(`${API_DOMAIN}storage/files/`, reqParams)
        .then((response) => {
            if (!response.ok) {
                toast.error('Что-то пошло не так');
                throw response.json();
            }

            if (response.status === 204) {
                toast.error('Что-то пошло не так');

                return '';
            }

            return response.json();
        });
}
